import React from "react";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { convertKeysToCamelCase } from "../../util/convertCamelCase";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import formatDate from "../../util/formatdate";
import "./index.css";
import { PrimaryButton } from "../../StyledCss/styledbtn";
import { getEmployeesLeavesHistory, exportLeaveHistory } from "../../api/services/hroneApi";
import LoadingView from "../LoadingView";
import FailureView from "../FailureView";
import { usePermissions } from "../../redux/slices/permissionsSlice";
import { FEATURE_CODES } from "../../util/featureCodes";
const apiStatusConstants = {
  initial: "INITIAL",
  success: "SUCCESS",
  failure: "FAILURE",
  inProgress: "IN_PROGRESS",
};
const TotalLeavesHistory = () => {
  const date = new Date();
  const [startMonth, setStartMonth] = useState(date);
  const [endMonth, setEndMonth] = useState(date);
  const [leavesHistoryData, setLeavesHistoryData] = useState([]);
  const [apiStatus, setApiStatus] = useState(apiStatusConstants.initial);
  //   const id = loginDetails.details.response.id;
  const formattedStartMonth = format(startMonth, "yyyy-MM");
  const formattedEndMonth = format(endMonth, "yyyy-MM");
  const { hasPermission } = usePermissions();
  const [loadingStates, setLoadingStates] = useState({
      exportCustom: false,
    }); 
    const setLoading = (operation, isLoading) => {
      setLoadingStates((prev) => ({ ...prev, [operation]: isLoading }));
    };

  useEffect(() => {
    getLeavesHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startMonth, endMonth]);

  const getLeavesHistory = async () => {
    try {
      setApiStatus(apiStatusConstants.inProgress);
      const response = await getEmployeesLeavesHistory(
        formattedStartMonth,
        formattedEndMonth
      );
      if (response.ok) {
        const leavesHistory=await response.json();
        const data = leavesHistory.data
        const updatedHistoryData = data.map((eachItem) =>
          convertKeysToCamelCase(eachItem)
        );

        const updatedData = updatedHistoryData.map((eachItem) => {
          const startDate = formatDate(eachItem.startDate);
          const endDate = formatDate(eachItem.endDate);
          return { ...eachItem, startDate, endDate };
        });

        setLeavesHistoryData(updatedData);
      }
    } catch (error) {}
  
    finally{
      setApiStatus(apiStatusConstants.success);
    }
  };
  const handleExportData = async () => {
  
    try {
      setLoading("exportCustom", true);
      const queryArg = {
        start_month: formattedStartMonth,
        end_month: formattedEndMonth,
      };
    const response = await exportLeaveHistory(queryArg);

      if (response.status === 200) {

        const contentDisposition = response.headers["content-disposition"];
        const filename = contentDisposition
          ?.split("filename=")[1]
          ?.replace(/"/g, "")
          .trim();
        const blob = response.data;
        const downloadLink = document.createElement("a");
        const blobUrl = URL.createObjectURL(blob);
        downloadLink.href = blobUrl;
        downloadLink.download = filename || "download.xlsx";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(blobUrl);
      } else {
        console.error("Error exporting data: ", response.message);
      }
    } catch (error) {
      console.error("Error exporting data:", error);
    } 
    finally {
      setLoading("exportCustom", false);
    }
  };
  const columnsLeaveHistory = [
    {
      headerName: "EMP ID",
      field: "employeeId",
      width: 120,
      floatingFilter: true,
      filter: true,
      suppressMenu: true
    },

    {
      headerName: "NAME",
      field: "fullName",
      filter: true,
      sortable: true,
      floatingFilter: true,
      tooltipField: "fullName",
      suppressMenu: true
    },
    {
      headerName: "START DATE",
      field: "startDate",
      floatingFilter: true,
      filter: true,
      suppressMenu: true
    },
    {
      headerName: "END DATE",
      field: "endDate",
      floatingFilter: true,
      filter: true,
      suppressMenu: true
    },
    {
      headerName: "REQUEST TYPE",
      field: "requestType",
      floatingFilter: true,
      filter: true,
      suppressMenu: true
    },
    {
      headerName: "DAYS",
      field: "days",
      width: 100,
      floatingFilter: true,
      filter: true,
      suppressMenu: true
    },
    {
      headerName: "STATUS",
      field: "status",
      width: 150,
      floatingFilter: true,
      filter: true,
      suppressMenu: true
    },
    {
      headerName: "APPROVED BY",
      field: "approvedBy",
      width: 200,
      floatingFilter: true,
      filter: true,
      suppressMenu: true
    },
    {
      headerName: "REASON",
      field: "leaveReason",
      tooltipField: "leaveReason",
      width: 300,
      floatingFilter: true,
      filter: true,
      suppressMenu: true
    },
    {
      headerName: "REJECT REASON",
      field: "rejectedReason",
      tooltipField: "rejectedReason",
      width: 300,
      floatingFilter: true,
      filter: true,
      suppressMenu: true
    },
  ];
  const selectDates = () => (
    <div className="d-flex align-items-center justify-content-end me-3">
      <div className="d-flex flex-row flex-wrap justify-content-end gap-2">
        <div className="month-picker ">
          <label className="mb-1">Start Month</label>
          <DatePicker
            selected={startMonth}
            onChange={(date) => {
              if (date) {
                setStartMonth(date);
                if (date > endMonth) {
                  setEndMonth(date);
                }
              } else {
                setStartMonth(new Date());
              }
            }}
            showMonthYearPicker
            dateFormat="MMMM yyyy"
            className="date-input-label"
          />
        </div>
        <div className="month-picker ">
          <label className="mb-1">End Month</label>
          <DatePicker
            selected={endMonth}
            onChange={(date) => {
              if (date) {
                setEndMonth(date);
              } else {
                setEndMonth(new Date());
              }
            }}
            showMonthYearPicker
            dateFormat="MMMM yyyy"
            className="date-input-label"
            minDate={startMonth}

          />
        </div>
         {hasPermission(FEATURE_CODES.LEAVE_ALL_HISTORY_EXPORT) && (
          <div className="d-flex flex-column align-self-end me-3 pl-3 pl-3">
            <PrimaryButton
              style={{ textAlign: "center", width: "auto" }}
              type="button"
              onClick={handleExportData}
            >
              {loadingStates.exportCustom ? "Exporting..." : "Export"}
            </PrimaryButton>
          </div>
        )}
      </div>
    </div>
  );

  const renderLeavesHistory = () => (
    <div
      className="ag-theme-alpine "
      style={{
        height: "60vh",
        fontSize: "14px",
        marginLeft: "15px",
        marginRight: "15px",
        marginTop: "10px",
        fontFamily: "Arial, Helvetica, sans-serif",
      }}
    >
      {/* {selectDates()} */}
      <AgGridReact
        rowData={leavesHistoryData}
        columnDefs={columnsLeaveHistory}
        pagination={true}
        paginationPageSize={20}
        enableCellTextSelection={true}
      ></AgGridReact>
    </div>
  );

  const renderData = () => {
    switch (apiStatus) {
      case apiStatusConstants.inProgress:
        return <LoadingView />;
      case apiStatusConstants.success:
        return renderLeavesHistory();
      case apiStatusConstants.failure:
        return <FailureView onClickRetry={getLeavesHistory} />;
      default:
        return null;
    }
  };

  return (
    <>
      {selectDates()}
      <div className="table-container">{renderData()}</div>
    </>
  );
};

export default TotalLeavesHistory;
